module.exports = __webpack_public_path__ + "static/media/logo-zero-124.d9201396.png";